export default __webpack_public_path__ + "static/media/video.20ec92b0.svg";